<template>
  <a
    :href="link.url"
    :target="link.newWindow ? '_blank' : '_self'"
    :title="link.title"
    v-on:mouseenter="noHover = false"
    v-on:mouseleave="noHover = true"
  >
    <i
      :class="[link.icon, { noHover: noHover }]"
      :style="{ background: link.color }"
    ></i>
    <span v-if="showLabel" v-text="link.text"></span>
  </a>
</template>

<script>
export default {
  name: "SocialSharingLink",
  props: {
    showLabel: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      noHover: true
    };
  }
};
</script>
